<template>

  <v-autocomplete
      prepend-icon="business"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      v-model="item"
      :label="$te(label) ? $t(label) : label"
      :loading="loading"
      :error="hasInputErrors('agencia')"
      :error-messages="getInputErrors('agencia')"
      color="secondary"
      item-color="secondary"
      :clearable="clearable"
      :multiple="multiple"
      :readonly="readonly"
      :rules="rules"
  ></v-autocomplete>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import AgenciaProvider from "../../providers/AgenciaProvider"

export default {
  name: "AgenciaCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    rules: {type: Array},
    clearable: {type: Boolean, default: false},
    multiple: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    itemValue: {type: String, default: 'id'},
    itemText: {type: String, default: 'nombre'},
    label:  {type: String, default: 'cobrox.persona.labels.agencia'},
  },
  data() {
    return {
      items: [],
      loading: false,
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      AgenciaProvider.fetchAgencia().then(r => {
        this.items = r.data.fetchAgencia
      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    }

  }
}
</script>

<style scoped>

</style>

